import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetInventoryAPiService from './AssetInventoryAPiService';
import { setAssessmentCreationSuccess } from 'Store/AssetInventory/Assessments/AssessmentAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { GET_BRANCH_ADMIN_USER_DETAILS, GET_COST_CENTER_GRID_BY_USERID, GET_USER_ON_SEARCH, GET_IS_COSTCENTER_SAVED_SUCCESSFULLY, GET_IS_COSTCENTER_VALID_FOR_SAVE, GET_REMOVE_COST_CENTER_FOR_USER, GET_COST_CENTER_BYID_AND_ROLE } from 'Store/AssetInventory/BranchAdminAccess/BranchAdminAccessType';
import { setBranchAdminUserDetails, setCostCenterByIdAndRole, setCostCenterGridByUserId, setIsCostCenterSavedSuccessfully, setIsCostCenterValidForSave, setIsRemoveCostCenterForUser, setUserOnSearch } from 'Store/AssetInventory/BranchAdminAccess/BranchAdminAccessAction';
import { take } from 'ramda';

function* getUserOnSearchSaga(req: any): any {
    try {
        yield put(globalLoaderText("Getting Cost Center...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `asssetinventory/user/${req?.val}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setUserOnSearch(response))
        }
        else {
            yield put(setUserOnSearch(null))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
        yield put(setAssessmentCreationSuccess([]))
    }
}

function* getBranchAdminUserDetailsSaga(req: any): any {
    try {
        yield put(globalLoaderText("Getting User Details...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `asssetinventory/userdetails/${req?.val}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setBranchAdminUserDetails(response))
        }
        else {
            yield put(setBranchAdminUserDetails(null))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
        yield put(setAssessmentCreationSuccess(null))
    }
}

function* getCostCenterByUserIdSaga(req: any): any {
    try {
        yield put(globalLoaderText("Getting Cost Center...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `asssetinventory/branchadmin/costcenter`,
            apiMethod: apiMethod.POST,
            payload: req?.val
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setCostCenterGridByUserId(response))
        }
        else {
            yield put(setCostCenterGridByUserId(null))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
        yield put(setCostCenterGridByUserId(null))
    }
}

function* getIsCostCenterValidSaga(req: any): any {
    try {
        yield put(globalLoaderText("Validating Cost Center...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `asssetinventory/validate/${req?.val?.userId}/${req?.val?.costCenterId}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(globalLoaderText(""));
        yield put(setIsCostCenterValidForSave(response))
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
        yield put(setIsCostCenterValidForSave(null))
    }
}

function* getIsCostCenterSaveSaga(req: any): any {
    try {
        yield put(globalLoaderText("Saving Cost Center...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `asssetinventory/costcenter`,
            apiMethod: apiMethod.POST,
            payload: req?.val
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(globalLoaderText(""));
        yield put(setIsCostCenterSavedSuccessfully(response))
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
        yield put(setIsCostCenterSavedSuccessfully(null))
    }
}

function* getRemoveCostCenterSaga(req: any): any {
    try {
        yield put(globalLoaderText("Removing Cost Center...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `asssetinventory/costcenter`,
            apiMethod: apiMethod.DELETE,
            payload: req?.val
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        yield put(globalLoaderText(""));
        yield put(setIsRemoveCostCenterForUser(response))
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
        yield put(setIsRemoveCostCenterForUser(null))
    }
}

function* getCostCenterByIdAndRoleSaga(req: any): any {
    try {
        yield put(globalLoaderText("Getting Cost Center...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `asssetinventory/costcenter/${req?.val?.searchValue}/${req?.val?.userId}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setCostCenterByIdAndRole(response))
        }
        else {
            yield put(setCostCenterByIdAndRole(null))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
        yield put(setCostCenterByIdAndRole(null))
    }
}

function* watchCreateAssement() {
    yield takeEvery(GET_USER_ON_SEARCH, getUserOnSearchSaga)
    yield takeEvery(GET_BRANCH_ADMIN_USER_DETAILS, getBranchAdminUserDetailsSaga)
    yield takeEvery(GET_COST_CENTER_GRID_BY_USERID, getCostCenterByUserIdSaga)
    yield takeEvery(GET_IS_COSTCENTER_VALID_FOR_SAVE, getIsCostCenterValidSaga)
    yield takeEvery(GET_IS_COSTCENTER_SAVED_SUCCESSFULLY, getIsCostCenterSaveSaga)
    yield takeEvery(GET_REMOVE_COST_CENTER_FOR_USER, getRemoveCostCenterSaga)
    yield takeEvery(GET_COST_CENTER_BYID_AND_ROLE, getCostCenterByIdAndRoleSaga)
}

export default function* combinedSaga() {
    yield all([
        watchCreateAssement()
    ])
}